(function () {
  'use strict';

  /* Sticky header shadow */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = header.querySelector('[data-burger]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('menu-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* Hero slideshow */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var dotsWrap = hero.querySelector('[data-hero-dots]');
    var idx = 0, timer = null;
    var dots = [];
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'hero__dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(d); dots.push(d);
    });
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function restart() {
      clearInterval(timer);
      if (hero.dataset.autoplay === 'true') timer = setInterval(function () { go(idx + 1); }, parseInt(hero.dataset.speed, 10) || 6000);
    }
    hero.querySelector('[data-hero-prev]').addEventListener('click', function () { go(idx - 1); restart(); });
    hero.querySelector('[data-hero-next]').addEventListener('click', function () { go(idx + 1); restart(); });
    go(0); restart();
    document.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1 && hero.contains(e.target)) { go(i); clearInterval(timer); }
    });
  });

  /* Product carousels */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]');
    function step() { var item = track.querySelector('.carousel__item'); return item ? item.getBoundingClientRect().width + 20 : 300; }
    c.querySelector('[data-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    c.querySelector('[data-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Collection sort + filters */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Product page: gallery + variant picker */
  var product = document.querySelector('[data-product]');
  if (product) {
    var main = product.querySelector('[data-main-image]');
    product.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) main.src = btn.getAttribute('data-thumb');
        product.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    var dataEl = product.querySelector('[data-variants]');
    var selects = product.querySelectorAll('[data-option]');
    if (dataEl && selects.length) {
      var variants = JSON.parse(dataEl.textContent);
      var idInput = product.querySelector('[data-variant-id]');
      var priceEl = product.querySelector('[data-price]');
      var compareEl = product.querySelector('[data-compare]');
      var skuEl = product.querySelector('[data-sku]');
      var addBtn = product.querySelector('[data-add]');
      var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: product.dataset.currency || 'USD' });

      var update = function () {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) {
          return chosen.every(function (val, i) { return x['option' + (i + 1)] === val; });
        });
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        priceEl.textContent = fmt.format(v.price / 100);
        if (compareEl) {
          var on = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.hidden = !on;
          if (on) compareEl.textContent = fmt.format(v.compare_at_price / 100);
        }
        if (skuEl) skuEl.textContent = v.sku || '';
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.featured_image && v.featured_image.src && main) main.src = v.featured_image.src;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };
      selects.forEach(function (s) { s.addEventListener('change', update); });
    }
  }
})();
